module.exports = __webpack_public_path__ + "img/progress-bar-chevron.d9fd621a.svg";